angular.module('qkr')
    .factory('subscriptionService', subscriptionService);
subscriptionService.$inject = [];
function subscriptionService() {

    let listSubscribers = [];

    const publicMethods = () => {
        return {
            subscribeAction: (action, callback) => {
                if(callback && !listSubscribers[action]) {
                    listSubscribers[action] = callback;
                }
            },
            executeAction: (action, param) => {
                const actionToExecute = listSubscribers[action];
                actionToExecute(param);
            },
            removeAction: (action) => {
                const index = listSubscribers.indexOf(action);
                listSubscribers.splice(index, 1);
            }
        }
    }
    return publicMethods();
}



// WEBPACK FOOTER //
// ./src/services/subscription.service.js